import { render, staticRenderFns } from "./ExamIcon.vue?vue&type=template&id=d7f3bc4a&"
import script from "./ExamIcon.vue?vue&type=script&lang=js&"
export * from "./ExamIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports